import axios from 'axios';
import {utils} from "@/util/utils";
import {URL_BASE} from "@/config";
import Vue from 'vue';

function getToken() {
    return utils.cookie.getCookie("wms_token");
}

export function axiosConfig() {
    const instance = axios.create({
        baseURL: URL_BASE, withCredentials: true, timeout: 500000,
    });

    // 请求拦截器
    instance.interceptors.request.use(config => {
        const token = getToken();
        if (!utils.string.vIsEmpty(token)) {
            config.headers['token'] = token;
            config.headers['user-type'] = 'admin';
        }
        return config;
    }, error => {
        return Promise.reject(error);
    });
    return instance;
}

const instance = axiosConfig();

/**
 * 异步发送 POST 请求的方法
 * @param {string} url - 目标 URL，发送请求的地址
 * @param {Object} params - 请求参数
 * @returns {Promise} 返回一个 Promise 对象，用于处理异步请求结果
 */
export async function vpost(url, params = {}) {
    try {
        const result = await instance.post(url, params);

        if (result.data.code !== 200) {
            Vue.prototype.$message.error('请求出错：' + result.data.msg);
            return Promise.reject(result.data.msg);
        }

        // 请求成功时，返回响应数据
        return result.data;
    } catch (error) {
        // 处理响应错误
        if (error.response) {
            Vue.prototype.$message.error(error.response.data.msg || error.response.data.message || '未知错误');
        } else if (error.request) {
            Vue.prototype.$message.error('请求未收到服务器响应');
        } else {
            Vue.prototype.$message.error('请求配置错误：' + error.message);
        }

        // 不显示详细错误的情况下，返回一个自定义的错误信息
        return Promise.reject('请求失败');
    }
}
